exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base-document{width:11in;min-height:8.5in}@page{size:11in 8.5in;margin:.5in}@media print{html,body,.main,.content{height:8.2in !important}#app{width:11in !important}#app .base-document{min-height:8.2in;height:8.2in;width:11in}}\n", ""]);

// exports
